import cn from "classnames"
import { useSelector } from "react-redux"

import style from "./style.module.scss"
import { getLastDate } from "./utils"

import { Icon, ImgAvatar, NonImgAvatar } from "components"
import { getFaceUrl } from "utils/helpers/psychologistUtil"
import { Chat } from "modules/Chat/utils/interfaces"
import { ROLES } from "utils/constants"
import { chatSelector } from "utils/store/selectors/chat"
import { userSelector } from "utils/store/selectors/user"

interface UserInList {
    data: Chat
    isActive: boolean
    onClick: (chatId: number) => void
}

export function UserInList({ data, isActive, onClick }: UserInList) {
    const { role } = useSelector(chatSelector)
    const { clientHash, psyHash } = useSelector(userSelector)
    const hasUnreadMessage = data.unreadCount > 0
    const lastMessage = data.lastMessage
    const userHash = role === ROLES.CLIENT ? clientHash : psyHash

    return (
        <div
            className={cn(style.container, { [style.activeChat]: isActive })}
            onClick={() => onClick(data.chatId)}
        >
            <div className={style.image}>
                <ImgAvatar
                    src={getFaceUrl(data.avatar, data.userId)}
                    size="W80"
                    className={style.userAvatar}
                    fallback={() => (
                        <NonImgAvatar size="W80" className={style.userAvatar}>
                            {data.name}
                        </NonImgAvatar>
                    )}
                />
            </div>
            <div className={style.borderBottom}>
                <div className={style.info}>
                    <div className={style.name}>{data.name}</div>
                    {data.email && <div className={style.email}>{data.email}</div>}
                </div>
                <div className={style.date}>
                    {!hasUnreadMessage &&
                        lastMessage &&
                        lastMessage.viewed &&
                        userHash === lastMessage.userId && <Icon type="done-all" size={24} />}
                    {!hasUnreadMessage &&
                        lastMessage &&
                        !lastMessage.viewed &&
                        userHash === lastMessage.userId && <Icon type="done" size={24} />}
                    {lastMessage && lastMessage.timestamp && (
                        <div>{getLastDate(new Date(lastMessage.timestamp))}</div>
                    )}
                    {hasUnreadMessage && <div className={style.dot}>{data.unreadCount}</div>}
                </div>
            </div>
        </div>
    )
}
